<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [entityPath]="fieldName" [removable]="true" [title]="'wbo.report.member-selection.title'">
    <wbo-text-column [title]="'wbo.report.member-selection.column.memberFirstName'" field="memberFirstName"></wbo-text-column>
    <wbo-text-column [title]="'wbo.report.member-selection.column.memberLastName'" field="memberLastName"></wbo-text-column>
    <wbo-text-column [title]="'wbo.report.member-selection.column.membershipType'" field="membershipType"></wbo-text-column>
    <wbo-text-column [title]="'wbo.report.member-selection.column.memberNo'" field="memberNo"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromMember([$event])">
            <wbo-member-no-single-select-edit-control></wbo-member-no-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search (onSelect)="addFromMember($event)"
                                          [searchComponent]="MemberSearchPageComponent"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
